import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { SignupWizardService } from '@app/modules/signup-new/services/signup-wizard.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'sbnb-signup-mobile-page',
  templateUrl: 'signup-mobile-page.component.html',
})
export class SignupMobilePageComponent {
  loading = false;
  form = new UntypedFormGroup({
    phone: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    public signupUserService: SignupUserService,
    private signupWizardService: SignupWizardService
  ) {}

  onContinue() {
    if (!this.form.valid) return;

    this.loading = true;
    this.signupUserService
      .updatePhone(this.form.controls.phone.value)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => this.signupWizardService.next('mobile'));
  }
}
